export default __webpack_public_path__ + "static/blob10-e8efdcb663db9a1c583d7d9957dfbc2b.svg";